module.exports = __webpack_public_path__ + "media/components/assets/sujung_12-8b059048dc6cb6bd6fc987823acc1889.png";